<template>
    <div class="scroll-bg ei-long-figure-scroll">
        <div class="scroll-l"></div>
        <div class="scroll-r"></div>
        <div class="scroll-white"></div>
        <div class="scroll-content"
             :style="{backgroundImage:'url('+url+')',animationDuration:duration+'s'}" ref="scrollContent">
        </div>
    </div>
</template>

<script>
    export default {
        name: "EiLongFigureScroll",
        data() {
            return {
                duration: 0
            }
        },
        props: {
            url: {
                type: String,
                required: true
            },
            width: {
                type: Number,
                required: true
            },
            speed: {
                type: Number,
                default: 30
            }

        },
        mounted() {
            let startX = 870 - this.width
            let endX = 870 + this.width
            this.duration = parseInt(this.width / this.speed)
            let style = document.createElement('style')
            document.getElementsByTagName('head')[0].appendChild(style)
            style.appendChild(document.createTextNode(''))
            document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
                0%{  background-position-x: ${startX}px;}
                100%{ background-position-x: ${endX}px;}
            }`)
        }
    }
</script>

<style scoped lang="scss">
    div {
        box-sizing: border-box;
    }

    .scroll-bg {
        position: relative;
        margin-left: 25px;
        display: inline-block;
        width: 914px;
        height: 488px;
        background-image: url("./image/longscroll-l.png");
        background-repeat: no-repeat;
        z-index: 1;
    }


    .scroll-l {
        position: absolute;
        top: -2px;
        width: 53px;
        height: 488px;
        background-image: url("./image/longscroll-l.png");
        background-repeat: no-repeat;
        opacity: .9;
        z-index: 3;
    }

    .scroll-r {
        position: absolute;
        top: 0;
        right: 41px;
        width: 47px;
        height: 488px;
        background-image: url("./image/longscroll-r.png");
        background-repeat: no-repeat;
        opacity: .9;
        z-index: 3;
    }

    .scroll-white {
        position: absolute;
        top: 62px;
        left: 2px;
        width: 869px;
        height: 360px;
        border-radius: 10px;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, .6);
    }

    .scroll-content {
        position: absolute;
        top: 77px;
        left: 2px;
        width: 871px;
        height: 330px;
        cursor: pointer;
        overflow: hidden;
        background-repeat: repeat-x;
        background-size: auto 330px;
        animation-name: scroll;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
        z-index: 2;
    }

    .scroll-content:hover {
        animation-play-state: paused;
    }
</style>
